import { Image } from "@chakra-ui/image";
import logo from "../images/Logo-IM-bad.png";
import { Box, Center, VStack } from "@chakra-ui/layout";
import { Progress } from "@chakra-ui/react";

export default function LogoSplash() {
  return (
    <>
      <Center height='100vh' width='100%'>
        <VStack>
          <Image src={logo} alt='logo loader' maxHeight='420px' padding='10px' />
          <Box width='300px'>
            <Progress size='sm' isIndeterminate colorScheme='red' />
          </Box>
        </VStack>
      </Center>
    </>
  );
}
